import { PartialServiceMap, Environments } from '@innovyze/stylovyze';

const config: PartialServiceMap = {
	// Sample config for overwritting service endpoints
	[Environments.LOCAL]: {
		assets: 'https://saas-asset-management.info360-dev.com/dev',
		amInspection: 'https://saas-inspection-management.info360-dev.com/dev',
		amRisk: 'https://saas-risk-management.info360-dev.com/dev',
		amUpload: 'https://saas-upload-service.info360-dev.com/dev',
		// NOTE: no `tiles` override. Overriding here would win the
		// merge(serviceMap, mapOverride) inside getService and clobber the
		// `i-360-tileset-read-from-cloudos` flag-selected CloudOS host. The
		// legacy branch of getService already returns the same info360 host
		// for LOCAL/DEV when the flag is off.
	},
	[Environments.DEV]: {
		assets: 'https://saas-asset-management.info360-dev.com/dev',
		amInspection: 'https://saas-inspection-management.info360-dev.com/dev',
		amRisk: 'https://saas-risk-management.info360-dev.com/dev',
		amUpload: 'https://saas-upload-service.info360-dev.com/dev',
	},
};

export const apiEnv =
	(localStorage.getItem('apiEnv') as keyof typeof Environments) || undefined;

export default config;
